/* Scoped Services page interactions; Shopify Theme Editor reloads are handled below. */
(function(){function init(){if(!document.getElementById('hero'))return;

(function(){
var d=document,root=d.documentElement;root.classList.add('js');
var rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
var vw=d.getElementById('vw'),st=d.getElementById('stage');if(vw&&st){function fit(){st.style.transform='scale('+vw.clientWidth/760+')'}fit();addEventListener('resize',fit)}
/* process connectors */
var steps=[].slice.call(d.querySelectorAll('#process .step')),conn=d.getElementById('conn'),paths=[],glow;if(!conn||!steps.length)return;
function build(){
 conn.innerHTML='';paths=[];
 if(getComputedStyle(conn).display==='none')return;
 var W=conn.clientWidth,cw=(W-78)/4,ns='http://www.w3.org/2000/svg',cols=['#7658FF','#FF8B5B','#7658FF'],dots=['#F456A9','#FF8B5B','#7658FF'];
 for(var i=0;i<Math.min(steps.length-1,3);i++){
  var x0=i*(cw+26)+154,x1=(i+1)*(cw+26)+(i==2?22:37),y0=46,y1=0,p=d.createElementNS(ns,'path');
  p.setAttribute('d','M'+x0+' '+y0+'C'+(x0+46)+' '+(y0+8)+' '+(x1-40)+' '+(y1+34)+' '+x1+' '+(y1+18));
  p.setAttribute('pathLength',1);p.style.stroke=cols[i];conn.appendChild(p);paths.push(p);
  var c=d.createElementNS(ns,'circle');c.setAttribute('cx',x0);c.setAttribute('cy',y0);c.setAttribute('r',5);c.setAttribute('fill',dots[i]);conn.appendChild(c);
 }
 glow=d.createElementNS(ns,'circle');glow.setAttribute('r',6);glow.setAttribute('class','glow');conn.appendChild(glow);
}
build();addEventListener('resize',function(){var was=played;build();if(was&&!rm)paths.forEach(function(p){p.style.transition='none';p.classList.add('go')})});
var played=false;
function travel(p,dur){
 if(!glow||!p)return;var L=p.getTotalLength(),t0=null;glow.style.opacity=1;
 (function f(t){if(!t0)t0=t;var k=Math.min((t-t0)/dur,1),pt=p.getPointAtLength(L*k);glow.setAttribute('cx',pt.x);glow.setAttribute('cy',pt.y);if(k<1)requestAnimationFrame(f);else glow.style.opacity=0})(performance.now());
}
function runProc(){
 played=true;
 if(rm){steps.forEach(function(s){s.classList.add('on','done','dim')});paths.forEach(function(p){p.classList.add('go')});return}
 var t=0;
 steps.forEach(function(s,i){
  setTimeout(function(){s.classList.add('on');var nb=s.querySelector('.num');if(nb){nb.classList.remove('pulse');void nb.offsetWidth;nb.classList.add('pulse')}
   if(i==2)setTimeout(function(){s.classList.add('dim')},1200);
   if(i==3)setTimeout(function(){s.classList.add('done')},1400);
   if(paths[i]){setTimeout(function(){paths[i].classList.add('go');travel(paths[i],1300)},900)}
  },t);t+=2300;
 });
}
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;
  if(e.target.id==='steps'&&!played){runProc()}
 io.unobserve(e.target)})},{threshold:.2});
io.observe(d.getElementById('steps'));
/* narrow layouts: no connectors, show steps as they scroll in */
var narrow=function(){return getComputedStyle(conn).display==='none'};
if(narrow()&&!rm){var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');if(e.target.classList.contains('s3'))setTimeout(function(){e.target.classList.add('dim')},1200);if(e.target.classList.contains('s4'))setTimeout(function(){e.target.classList.add('done')},1400)}})},{threshold:.35});steps.forEach(function(s){io2.observe(s)});played=true}
})();



(()=>{
const d=document,caps=[...d.querySelectorAll('#capabilities .cap')];if(!caps.length)return;
d.documentElement.classList.add('js');
const rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
const ease=x=>1-Math.pow(1-x,3);
const fmt=(v,el)=>v.toFixed(+el.dataset.dec||0)+(el.dataset.suf||'');
const seqOf=el=>JSON.parse(el.dataset.seq);
caps.forEach(c=>c.querySelectorAll('[data-seq]').forEach(el=>{const s=seqOf(el);el.textContent=fmt(rm?s.at(-1)[1]:s[0][0],el)}));
function count(cap){cap.querySelectorAll('[data-seq]').forEach(el=>{
  const seq=seqOf(el),last=seq.at(-1),t0=performance.now();
  cancelAnimationFrame(el._r);
  (function f(now){const t=now-t0;let v=seq[0][0];
    for(const[a,b,dl,du]of seq){if(t>=dl+du)v=b;else{if(t>=dl)v=a+(b-a)*ease((t-dl)/du);break}}
    el.textContent=fmt(v,el);
    if(t<last[2]+last[3])el._r=requestAnimationFrame(f)})(t0)})}
function play(cap){cap.classList.remove('is-play');void cap.offsetWidth;cap.classList.add('is-play');cap._t=Date.now();count(cap)}
if(rm||!('IntersectionObserver'in window)){caps.forEach(c=>c.classList.add('is-play'));return}
const cols=()=>innerWidth>=1024?3:innerWidth>=640?2:1;
const io=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;io.unobserve(e.target);
  setTimeout(()=>play(e.target),(+e.target.dataset.i%cols())*170)}),{threshold:.3});
caps.forEach(c=>io.observe(c));
/* keep the stories looping while a card is on screen */
const seen=new Set();
const io2=new IntersectionObserver(es=>es.forEach(e=>e.isIntersecting?seen.add(e.target):seen.delete(e.target)),{threshold:.3});
caps.forEach(c=>io2.observe(c));
const loop=c=>{c._t=Date.now();c.classList.add('out');setTimeout(()=>{play(c);c.classList.remove('out')},450)};
setInterval(()=>{if(document.hidden)return;caps.forEach((c,i)=>{if(c._t&&Date.now()-c._t>9000+(i%3)*700)loop(c)})},1000);
if(matchMedia('(hover:hover) and (pointer:fine)').matches){
  const again=c=>{if(c._t&&Date.now()-c._t>6500)play(c)};
  caps.forEach(c=>{c.addEventListener('mouseenter',()=>again(c));c.addEventListener('focusin',()=>again(c))})}
})();



(function(){
  const windowEl=document.getElementById('ufe-review-window');
  if(!windowEl||windowEl.dataset.ufReady)return;windowEl.dataset.ufReady='true';
  const track=windowEl.querySelector('.ufe-review-track');
  const cards=Array.from(track.querySelectorAll('.ufe-review-card'));if(!cards.length)return;
  const prev=document.querySelector('#client-reviews .ufe-review-prev');
  const next=document.querySelector('#client-reviews .ufe-review-next');
  const counter=document.getElementById('ufe-review-count');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function sizes(){
    const gap=parseFloat(getComputedStyle(track).gap)||0;
    const stride=cards[0].getBoundingClientRect().width+gap;
    const visible=Math.max(1,Math.round((windowEl.clientWidth+gap)/stride));
    return {stride,visible,max:Math.max(0,cards.length-visible)};
  }
  function update(){
    const {stride,visible,max}=sizes();
    const index=Math.min(max,Math.max(0,Math.round(windowEl.scrollLeft/stride)));
    prev.disabled=index===0;
    next.disabled=index>=max;
    const a=String(index+1).padStart(2,'0');
    const b=String(Math.min(cards.length,index+visible)).padStart(2,'0');
    counter.textContent=a+'–'+b+' / '+String(cards.length).padStart(2,'0');
  }
  function move(direction){
    const {stride,max}=sizes();
    const current=Math.round(windowEl.scrollLeft/stride);
    const target=Math.min(max,Math.max(0,current+direction));
    windowEl.scrollTo({left:target*stride,behavior:reduced.matches?'auto':'smooth'});
    if(reduced.matches)update();
  }
  prev.addEventListener('click',()=>move(-1));
  next.addEventListener('click',()=>move(1));
  let scheduled=false;
  windowEl.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;update()})}},{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();
})();

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',function(){
 var r=document.getElementById('client-reviews');if(r){var w=r.querySelector('.ufe-review-window');if(w){w.dataset.ufReady='';var t=w.querySelector('.ufe-review-track'),a=[...t.querySelectorAll('.ufe-review-card')],prev=r.querySelector('.ufe-review-prev'),next=r.querySelector('.ufe-review-next'),count=r.querySelector('.ufe-review-count');if(a.length&&prev&&next){function update(){var gap=parseFloat(getComputedStyle(t).gap)||0,stride=a[0].getBoundingClientRect().width+gap,visible=Math.max(1,Math.round((w.clientWidth+gap)/stride)),index=Math.min(Math.max(0,a.length-visible),Math.round(w.scrollLeft/stride));prev.disabled=index===0;next.disabled=index>=a.length-visible;count.textContent=String(index+1).padStart(2,'0')+'–'+String(Math.min(a.length,index+visible)).padStart(2,'0')+' / '+String(a.length).padStart(2,'0')}prev.onclick=function(){w.scrollBy({left:-(a[0].getBoundingClientRect().width+18),behavior:'smooth'})};next.onclick=function(){w.scrollBy({left:a[0].getBoundingClientRect().width+18,behavior:'smooth'})};w.addEventListener('scroll',update,{passive:true});update()}}}
 document.querySelectorAll('#capabilities .cap').forEach(function(c){c.classList.add('is-play')});document.querySelectorAll('#process .step').forEach(function(s){s.classList.add('on','done')});var v=document.getElementById('vw'),s=document.getElementById('stage');if(v&&s)s.style.transform='scale('+v.clientWidth/760+')';
});})();